import { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const PermissionContext = createContext();

export const usePermissions = () => useContext(PermissionContext);

export const PermissionProvider = ({ children }) => {
  const { user } = useAuth();

  const userPermissions = useMemo(() => {
    return user?.permissions || [];
  }, [user]);

  const userRoles = useMemo(() => {
    return user?.roles || [];
  }, [user]);

  const hasPermission = (permission) => {
    return userPermissions.includes(permission);
  };

  const hasAnyPermission = (permissions) => {
    return permissions.some(p => userPermissions.includes(p));
  };

  const hasAllPermissions = (permissions) => {
    return permissions.every(p => userPermissions.includes(p));
  };

  const hasRole = (role) => {
    return userRoles.includes(role);
  };

  return (
    <PermissionContext.Provider
      value={{
        userPermissions,
        userRoles,
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
        hasRole,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};
